import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { store } from './store';
import { ToastContainer } from './components/Toast';
import App from './App';
import './sass/main.scss';
import { msalConfig } from './auth/msal';

const container = document.getElementById('root')!;
const root = createRoot(container);

const msalInstance = new PublicClientApplication(msalConfig);

async function bootstrap() {
    await msalInstance.initialize();

    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <MsalProvider instance={msalInstance}>
                    <ToastContainer />
                    <App />
                </MsalProvider>
            </Provider>
        </React.StrictMode>
    );
}

void bootstrap();
